<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="800px"
  >
    <template v-slot:activator="{ on }">
      <v-btn 
        icon
        class="mt-n1"
        v-on="on"
      >
        <v-icon color="hrissecondary">
          mdi-plus-circle
        </v-icon>
      </v-btn>
    </template>
    
    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      title="Create Dependent's History"
      text="Create for previous year record if current year record is different from previous year"
      class="mb-0"
      :loading="loading"
    >
      <form v-if="dialog && !loading">
        <v-container>
          <v-row>
            <v-col
              cols="6"
              class="pb-0"
            >
              <v-autocomplete
                v-model="relationStatus"
                v-validate="'required'"
                :error-messages="errors.collect('relationStatus')"
                :items="relationStatuses"
                data-vv-name="relationStatus"
                data-vv-as="relation status"
                item-text="name"
                item-value="id"
                label="Past Year Relation Status"
                :class="{
                  'required':!relationStatus
                }"
                outlined
              >
                <template v-slot:item="data">
                  <v-list-item-content>
                    <span class="font-weight-bold">{{ data.item.name }}</span>
                    <span style="width:100px">{{ data.item.description }}</span>
                  </v-list-item-content>
                </template>
              </v-autocomplete>
            </v-col>

            <v-col
              v-show="relationStatus === 2"
              cols="6"
              class="pb-0"
            >
              <v-autocomplete
                v-model="educationLevel"
                v-validate="relationStatus === 2 ? 'required' : ''"
                :error-messages="errors.collect('educationLevel')"
                :items="educationLevels"
                data-vv-name="educationLevel"
                data-vv-as="education level"
                item-text="name"
                item-value="key"
                label="Past Year Education Level"
                outlined
              />
            </v-col>

            <v-col
              cols="12"
              class="pb-0"
            >
              <span> Disabled? </span>
              <v-radio-group
                v-model="isDisabled"
                class="mt-0"
                row
              >
                <v-radio
                  label="No"
                  :value="0"
                />
                <v-radio
                  label="Yes"
                  :value="1"
                /> 
              </v-radio-group>
            </v-col>

            <v-col
              v-if="dependentRelation.id === 2"
              :cols="isTaxRelief ? 6 : 12"
              class="pb-0"
            >
              <span> Tax Relief? </span>
              <v-radio-group
                v-model="isTaxRelief"
                class="mt-0"
                row
                @change="isTaxRelief ? taxReliefPercentage = 100 : taxReliefPercentage = 0"
              >
                <v-radio
                  label="No"
                  :value="0"
                />
                <v-radio
                  label="Yes"
                  :value="1"
                /> 
              </v-radio-group>
            </v-col>
            <v-col
              v-show="dependentRelation.id === 2 && isTaxRelief"
              cols="6"
              class="pb-0"
            >
              <v-autocomplete
                v-model="taxReliefPercentage"
                :error-messages="errors.collect('taxReliefPercentage')"
                :items="percentages"
                data-vv-name="taxReliefPercentage"     
                data-vv-as="tax relief percentage"
                item-text="name"
                item-value="key"
                label="Past Year Tax Relief Percentage"
                outlined
              />
            </v-col>

            <v-col
              cols="6"
              class="pb-0"
            >
              <v-autocomplete
                v-model="startYear"
                v-validate="'required'"
                :items="years"
                :error-messages="errors.collect('startYear')"
                data-vv-name="startYear"     
                data-vv-as="start year"
                label="Payroll Start Year"
                item-text="value"
                item-value="id"
                outlined
              />
            </v-col>

            <v-col
              cols="6"
              class="pb-0"
            >
              <v-autocomplete
                v-model="endYear"
                :items="years"
                :error-messages="errors.collect('endYear')"
                data-vv-name="endYear"     
                data-vv-as="end year"
                label="Payroll End Year"
                item-text="value"
                item-value="id"
                outlined
              />
            </v-col>
          </v-row>
        </v-container>
      </form>

      <v-card-actions v-if="dialog && !loading">
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          class="px-10"
          @click="dialog = false"
        >
          Cancel
        </v-btn>
        <v-btn
          :loading="progressing"
          color="hrissecondary"    
          class="white--text px-10"      
          @click="submitForm"
        >
          Create
        </v-btn>
      </v-card-actions> 
    </material-card> 
  </v-dialog>
</template>

<script>
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    props: {
      dependentId: {
        type: Number,
        required: true,
      },
      dependentRelation: {
        type: Object,
        required: true,
      },
    },
    data () {
      return {
        dialog: false,
        progressing: false,
        startYear: null,
        endYear: null,
        educationLevel: null,
        years: [],
        relationships: [],
        relationStatuses: [],
        loading: false,
        relationStatus: null,
        isDisabled: 0,
        isTaxRelief: 1,
        taxReliefPercentage: 100,
        percentages: [
          { key: 50, name: '50 %' },
          { key: 100, name: '100 %' },
        ],
        educationLevels: [
          { key: 'PRIMARY', name: 'Primary' },
          { key: 'SECONDARY', name: 'Secondary' },
          { key: 'ALEVEL', name: 'A-Level' },
          { key: 'CERTIFICATE', name: 'Certificate' },
          { key: 'MATRICULATION', name: 'Matriculation' },
          { key: 'PREPARATORY_COURSES', name: 'Preparatory Courses' },
          { key: 'DIPLOMA', name: 'Diploma in Malaysia (excluding matriculation/ preparatory courses)' },
          { key: 'OVERSEAS_DIPLOMA', name: 'Overseas Diploma' },
          { key: 'DEGREE', name: 'Degree in Malaysia' },
          { key: 'OVERSEAS_DEGREE', name: 'Overseas Degree' },
          { key: 'MASTER', name: 'Master in Malaysia' },
          { key: 'OVERSEAS_MASTER', name: 'Overseas Master' },
          { key: 'DOCTORATE', name: 'Doctorate in Malaysia' },
          { key: 'OVERSEAS_DOCTORATE', name: 'Overseas Doctorate' },
        ],
      }
    },
    watch: {
      dialog: function (value) {
        if (!value) return

        this.loading = true

        Promise.all([
          this.$api.hrisRelationships().list(),
          this.$api.hrisRelationStatuses().list(),
          this.$api.taxReliefs().listYears(),
        ])
          .then(([employee, relationStatus, years]) => {
            this.relationships = employee.data
            this.relationStatuses = relationStatus.data
            this.years = years.data.filter(year => {
              return year < this.$moment().format('YYYY')
            })

            this.loading = false
          })
      },
    },
    methods: { 
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.setProgressing(true)

            this.$api.hrisDependentHistories().create(this.dependentId, this.prepareFormData())
              .then(response => {
                if (response.status === 200) {
                  this.$emit('updated')
                  this.$snack({ message: response.data.status })

                  this.setProgressing(false)
                  this.dialog = false
                }
              })
          })
      },
      setProgressing (status) {
        this.progressing = status
      },
      prepareFormData () {
        if (this.relationStatus !== 2) {
          this.educationLevel = null
        }
        
        return {
          relationship_id: this.dependentRelation.id,
          relation_status_id: this.relationStatus,
          is_disabled: this.isDisabled,
          is_tax_relief: this.dependentRelation.id === 2 ? this.isTaxRelief : 1,
          tax_relief_percentage: this.isTaxRelief ? this.taxReliefPercentage : 0,
          education_level: this.educationLevel,
          start_year: this.startYear,
          end_year: this.endYear,
        }
      },
    },
  }
</script>

<style scoped>
.required >>> fieldset {
  border: 2px solid red;
}

.label-position >>> .v-label.v-label--active{
  margin-left:-28px;
  background:white;
  padding-right:1px
}
</style>
